export const chakraBadgeColorPaletteList = Object.freeze([
  {
    key: 'gray',
    name: '灰',
    foreground: '#27272a', // gray.800
    background: '#f4f4f5', // gray.100
  },
  {
    key: 'red',
    name: '赤',
    foreground: '#991919', // red.700
    background: '#fee2e2', // red.100
  },
  {
    key: 'orange',
    name: '橙',
    foreground: '#92310a', // orange.700
    background: '#ffedd5', // orange.100
  },
  {
    key: 'yellow',
    name: '黄',
    foreground: '#713f12', // yellow.800
    background: '#fef9c3', // yellow.100
  },
  {
    key: 'green',
    name: '緑',
    foreground: '#116932', // green.700
    background: '#dcfce7', // green.100
  },
  {
    key: 'teal',
    name: 'ティール',
    foreground: '#0c5d56', // teal.700
    background: '#ccfbf1', // teal.100
  },
  {
    key: 'blue',
    name: '青',
    foreground: '#173da6', // blue.700
    background: '#dbeafe', // blue.100
  },
  {
    key: 'cyan',
    name: 'シアン',
    foreground: '#0c5c72', // cyan.700
    background: '#cffafe', // cyan.100
  },
  {
    key: 'purple',
    name: '紫',
    foreground: '#641ba3', // purple.700
    background: '#f3e8ff', // purple.100
  },
  {
    key: 'pink',
    name: 'ピンク',
    foreground: '#a41752', // pink.700
    background: '#fce7f3', // pink.100
  },
]);

chakraBadgeColorPaletteList.forEach(x => Object.freeze(x));

export const chakraBadgeColorPaletteMap = Object.freeze(Object.fromEntries(
  chakraBadgeColorPaletteList.map(x => [x.key, x])
));
